import React, {Component} from 'react';

import WelcomeScreen from './screen-welcome';
import UsersApi from '../../../lib/users/users-api';
import Input from '../../../components/input-with-label';
import RegistrationLayout from "./registration-layout";
import RegistrationFormContainer from './registration-form-container';
import PaginationNumber from "../../../components/pagination-number";

import Checkbox from "../../../components/checkbox";
import AddButton from '../../../components/buttons/add-button';
import SkipButton from '../../../components/buttons-navigation/button-next';
import FormValidator from './form-validator';
import { message } from 'laravel-mix/src/Log';

class AddTeamScreen extends Component {

    constructor(props) {
        super(props);
        this.validator = new FormValidator([
            {
                field: 'team_email',
                method: 'isEmpty',
                validWhen: false,
                message: 'Enter an email address'
            },
            {
                field: 'team_email',
                method: 'isEmail',
                validWhen: true,
                message: 'Enter a valid email address'
            },
            {
                field: 'team_role',
                method: 'isEmpty',
                validWhen: false,
                message: 'Select an option'
            }
        ])
        this.state = {
            ...props,
            validation: this.validator.valid(),
            roles : []
        }
        this.submitted = false;
    }

    onCheckboxRoleChange(roleId) {

        if (this.props.values.team_role === roleId) {

            return this.props.onChange('team_role', null);
        }
        this.props.onChange('team_role', roleId);

    }

    handleChange(e) {
        this.props.onChange(e.target.name, e.target.value);
    }

    getRoles() {
        UsersApi.roles(1, 100).then(data => {
            this.setState({roles : data.data});
        });
    }


    componentDidMount() {
        this.getRoles();
    }

    onAddClick() {
        const validation = this.validator.validate({ ...this.props.values });

        this.setState({validation});

        this.submitted = true;

        if(validation.isValid) {
            const { values } = this.props;

            let members = [...this.props.values.team_add];
            
            members.push({
                team_email: values.team_email,
                team_role: values.team_role
            });

            this.props.onChange('team_add', members, () => {
                this.props.onChange('team_email', '');
            });
        }
    }

    onNextClick() {
        this.props.onNext();
    }

    onBackClick() {
        this.props.onBack();
    }

    getRoleById(roleId) {
        const index = _.findIndex(this.state.roles, (r) => {
            return r.id === roleId;
        })

        if(index !== -1) {
            return this.state.roles[index];
        }

        return {};
    }

    render() {
        const validation = this.state.validation
        const teamValues = this.props.values.team_add
        const { values } = this.props;
        return(
            <RegistrationLayout
                left={<WelcomeScreen img={"/assets/onboarding-screen/card-business-support.png"} label={"Enterprising Barnsley Business Support"} title={"Online business support and guidance as soon as you need it"} description={"With guides, news, events and more - you'll have access to useful features to guide your business forward int he right direction."}/>}

                right={<RegistrationFormContainer heading='Register your account' text="Already have an account?" linkText='Sign In' linkHref='/login'>
                    <div className="registration-form__container utils__gap--20">
                        <div className='registration-form__heading-conteiner utils__row'>
                            <h2>Ready to add your team?</h2>
                            <SkipButton onClick={this.onNextClick.bind(this)}>Skip</SkipButton>
                        </div>

                        <Input label="Team member email address" type="email" name="team_email" placeholder=""
                            value={values.team_email} onChange={this.handleChange.bind(this)} errors={[validation.team_email.message]} />
                        <div className='input-outer'>
                            <label>What is their role in the company?</label>
                            <div className='registration-form__checkboxes utils__row utils__alignItems--center utils__gap--20'>
                                {
                                    this.state.roles.map((role, index) => {
                                        return(
                                            <Checkbox
                                                text={role.name}
                                                checked={values.team_role === role.id}
                                                onChange={() => this.onCheckboxRoleChange(role.id) }
                                            />
                                        );
                                    })
                                }


                                <AddButton onClick={this.onAddClick.bind(this)} responsive={false}/>
                            </div>
                            {validation.team_role.message.length > 0 && <div className='input-outer__errors'><p>{validation.team_role.message}</p></div>}
                        </div>
                        <div className='team-list__container'>
                            <p>Invites to be Sent</p>
                            <div className='team-list__title'>
                                <p>Email address</p>
                                <p>Role</p>
                            </div>
                            {teamValues.map(({team_email, team_role}, index) => {
                                return <div key={index} className='team-list__row'>
                                <p key={team_email}>{team_email}</p>
                                <p key={team_email}>{ this.getRoleById(team_role).name}</p>
                            </div>
                            })}
                            {teamValues.length == 0 && <div className='team-list__empty'><p>No invites</p></div>}
                        </div>
                    </div>
                    <PaginationNumber currentPage={'3'}
                        onNextClick={this.onNextClick.bind(this)}
                        onBackClick={this.onBackClick.bind(this)}/>
                </RegistrationFormContainer>}
            />
        );
    }
}

export default AddTeamScreen;
